<template>
    <main class="contact-page">

        <!-- Header -->
        <theme-header />

        <!-- Breadcrumb -->
        <breadcrumb title="Contact" currentpage="contact" />

        <!-- Contact US -->
        <contact-us-section />

        <google-map-one />

        <!-- Footer -->
        <theme-footer />

        <!-- Back to Top -->
        <back-to-top  btnText="Back to top" :showIcon="true" />

    </main>
</template>

<script>
import ThemeFooter from '../components/common/ThemeFooter.vue'
import ThemeHeader from '../components/common/ThemeHeader.vue'
import BackToTop from '../components/pieces/BackToTop.vue'
import Breadcrumb from '../components/pieces/Breadcrumb.vue'
import GoogleMapOne from '../components/pieces/GoogleMapOne.vue'
import ContactUsSection from '../components/sections/ContactUsSection.vue'

export default {
    name: 'Contact',
    components: {
        ThemeHeader,
        ThemeFooter,
        BackToTop,
        Breadcrumb,
        ContactUsSection,
        GoogleMapOne
    }
}
</script>